import { Phone, Mail, Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "../ui/button";
import { COMPANY } from "../../data/products";

const NAV = [
  { label: "Hurt", href: "#hurt" },
  { label: "Produkty", href: "#produkty" },
  { label: "Kalkulator", href: "#kalkulator" },
  { label: "Zastosowanie", href: "#zastosowanie" },
  { label: "Pobierz", href: "#pobierz" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white border-b-2 border-black"
    >
      {/* Top bar */}
      <div className="bg-black text-white text-xs">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-9">
          <span className="font-tech uppercase tracking-widest text-zinc-300 flex items-center gap-2">
            <span className="hidden sm:inline">🇵🇱 Hurt + detal ·</span>
            <span className="text-red-500">Darmowa dostawa od 4 palet</span>
          </span>
          <div className="hidden md:flex items-center gap-6">
            <a
              href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
              className="flex items-center gap-2 hover:text-red-500 transition"
              data-testid="topbar-phone"
            >
              <Phone className="h-3.5 w-3.5" /> {COMPANY.phone}
            </a>
            <a
              href={`mailto:${COMPANY.email}`}
              className="flex items-center gap-2 hover:text-red-500 transition"
              data-testid="topbar-email"
            >
              <Mail className="h-3.5 w-3.5" /> {COMPANY.email}
            </a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <a
          href="#"
          className="flex items-center"
          data-testid="logo-link"
          aria-label="BUDOBET.PL — strona główna"
        >
          <img
            src="/budobet-logo-sm.png"
            alt="BUDOBET.PL"
            className="h-10 sm:h-11 w-auto object-contain"
            width="142"
            height="44"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.replace("#", "")}`}
              className="font-tech text-sm uppercase tracking-widest text-zinc-700 hover:text-red-600 transition font-semibold"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button
            asChild
            className="hidden md:inline-flex rounded-none bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-wider px-6 h-11"
            data-testid="header-cta-contact"
          >
            <a href="#kontakt">Zapytaj o cenę</a>
          </Button>
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 border-2 border-black"
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Red accent strip */}
      <div className="h-1 bg-red-600" />

      {/* Mobile nav */}
      {open && (
        <div
          className="lg:hidden bg-white border-t border-zinc-200"
          data-testid="mobile-menu"
        >
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="py-3 px-3 font-tech text-sm uppercase tracking-widest text-zinc-800 hover:bg-zinc-100 border-b border-zinc-100"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
